import R from 'app/assets/R'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { useHookTable } from './hook'
import { BaseRow } from 'app/components/common/BaseRow'
import { FilterManagement } from './components/FilterManagementTable'
import Export from './components/Export'
import { InventoryProvider } from 'app/context/ProviderContext'
import { MaterialCategoryProvider } from 'app/context/MaterialCategoryContext'
import { UnitProvider } from 'app/context/UnitContext'
import { WarehouseUnitProvider } from 'app/context/WarehouseUnitContext'
const MaterialImportContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    // fetchNewData,
    filter,
    handleChangeFilter,
    onClickExport,
  } = useHookTable()

  const mainComp = () => (
    <S.BaseManagementWrapper>
      <HeaderPage
        titleI18nKey={R.strings.material_import}
        rightComponent={
          <>
            <Export onPressExport={onClickExport} />
            {/* <Create fetchTable={fetchNewData} /> */}
          </>
        }
      />
      <S.RootWrapper>
        <BaseRow>
          <FilterManagement
            handleChangeFilter={handleChangeFilter}
            filterData={filter}
          />
        </BaseRow>
        <BaseTableManagement
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.loading}
          onChange={handleTableChange}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )

  return (
    <InventoryProvider>
      <MaterialCategoryProvider>
        <UnitProvider>
          <WarehouseUnitProvider>{mainComp()}</WarehouseUnitProvider>
        </UnitProvider>
      </MaterialCategoryProvider>
    </InventoryProvider>
  )
}
export default MaterialImportContainer
